import _ from 'underscore';
import defaultTemplate from 'text!./templates/address-details-default.html';
import bigToSmallTemplate from 'text!./templates/address-details-BigToSmall.html';
import postCodeBeforeCityTemplate from 'text!./templates/address-details-PostCodeBeforeCity.html';

export default ['LocaleService', 'AccountService', function (LocaleService, AccountService) {
    var addressConfig = LocaleService.getAddressConfig();
    var template = void 0;

    switch (addressConfig.pcfMode) {
        case 'BigToSmall':
            template = bigToSmallTemplate;
            break;
        case 'PostCodeBeforeCity':
            template = postCodeBeforeCityTemplate;
            break;
        default:
            template = defaultTemplate;
            break;
    }

    return {
        restrict: 'AE',
        template: template,
        scope: {
            address: '=',
            allContacts: '=',
            readonly: '@',
            addressType: '@',
            displayCountry: '@',
            defaultCountryCode: '@',
            disableZipCode: '=',
            disableCity: '=',
            disableCounty: '=',
            disableState: '=',
            showLoading: '=',
            hideFields: '='
        },

        link: function link(scope, element, attrs) {
            attrs.$observe('readonly', function (value) {
                scope.readonly = value === 'true';
            });

            var defaultCountryCode = scope.defaultCountryCode || LocaleService.getCountry().code;
            console.log("country details-->");
            console.log(LocaleService.getCountry().code);

            scope.isVisible = function (fieldName) {
                var visible = addressConfig.fieldNames.indexOf(fieldName) >= 0;
                if (scope.hideFields) {
                    visible = visible && !(_.contains(scope.hideFields, fieldName) || _.contains(_.map(scope.hideFields, function (idx) {
                        return idx + 'Kanji';
                    }), fieldName));
                }
                return visible;
            };

            scope.shouldShow = function (value) {
                return angular.isDefined(value.value);
            };
            //console.log(scope.address);


            //scope.address.state.aspects.required="true;"
            /* scope.address.state = {
            aspects : {    				
                         required: true,
                         visible: true,
                         //availableValues : $scope.newSubmissionView.value.state,
                         get validationMessages() {
                             return ['This is a required field'];
                         },
                         get valid() {
                             return $scope.address.state.value;
                         }
            }                  
                   
                 };*/

            scope.is_usZipCode = function (value) {
                if (value == '' || value == undefined) {
                    scope.error_exist = false;
                } else {
                    //scope.error_exist = true;
                    var regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
                    if (value != '' && !regexp.test(value)) {
                        scope.error_exist = true;
                    } else {
                        scope.error_exist = false;
                    }
                }
            };

            scope.is_mxZipCode = function (value) {
                if (value == '' || value == undefined) {
                    scope.error_exist = false;
                } else {
                    //scope.error_exist = true;
                    var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
                    if (value != '' && !regexp.test(value)) {
                        scope.error_exist = true;
                    } else {
                        scope.error_exist = false;
                    }
                }
            };

            /*scope.is_auZipCode = (value) => { 
            	if(value == '' || value == undefined){
            		scope.error_exist = false;
            	}
            	else{
            		//scope.error_exist = true;
            		var regexp = /^[0-9]{4}$/;
                    if (value!='' && !regexp.test(value))
                      {
                        scope.error_exist = true;
                      }
                    else
                      {
                    	scope.error_exist = false;
                      }
            	}
            }*/

            //for canada country
            scope.is_caZipCode = function (value) {
                if (value == '' || value == undefined) {
                    scope.error_exist = false;
                } else {
                    //scope.error_exist = true;
                    var regexp = /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/;
                    if (value != '' && !regexp.test(value)) {
                        scope.error_exist = true;
                    } else {
                        scope.error_exist = false;
                    }
                }
            };

            if (scope.address && scope.address.postalCode.value != "") {
                scope.$watch('address.postalCode.value', function (value) {
                    if (scope.address.country.value.code == 'US' && scope.address.postalCode.value != undefined) scope.is_usZipCode(value);
                    if (scope.address.country.value.code == 'CA' && scope.address.postalCode.value != undefined) scope.is_caZipCode(value);
                    if (scope.address.country.value.code == 'MX' && scope.address.postalCode.value != undefined) scope.is_mxZipCode(value);
                });
            }

            /* scope.countryCodes = scope.address.country.aspects.availableValues; 
             scope.newcountryCodes = _.reject(scope.countryCodes, function(val, key){ 
                 return val.code == 'US' || val.code== 'CA' || val.code == 'MX'; 
             }); 
             console.log(scope.newcountryCodes);
             scope.removedcountryCodes = _.reject(scope.countryCodes, function(val, key){ 
                 return val.code == 'US' || val.code== 'CA' || val.code == 'MX'; 
             });*/
            scope.countryCodes = [];
            angular.forEach(scope.address.country.aspects.availableValues, function (values) {
                if (values.code == 'US' || values.code == 'CA' || values.code == 'MX') {
                    scope.countryCodes.push(values);
                }
            });
            console.log(scope.countryCodes);

            scope.$watch('address.country.value', function (value) {
                console.log("selected Country");
                console.log("code -->");
                console.log(scope.address.country.value.code);
                if (scope.address.country.value.code == 'US') {
                    console.log(value.code);
                    if (scope.address && scope.address.postalCode.value != "") {
                        scope.is_usZipCode(scope.address.postalCode.value);
                    }
                    var StateListPromise = AccountService.getStates(value.code);
                    StateListPromise.then(function (data) {

                        scope.availableStates = [];
                        angular.forEach(data, function (result, resultkey) {
                            scope.result = result.split('~');
                            scope.availableStates.push(scope.result);
                        });
                        scope.desiredArray = [];
                        angular.forEach(scope.availableStates, function (splitedvalues) {
                            console.log(splitedvalues);
                            scope.desiredArray.push({ name: splitedvalues[0], code: splitedvalues[1] });
                        });
                        //console.log(scope.selected);
                        scope.selected = {
                            "value": scope.desiredArray[0],
                            "availableStates": scope.desiredArray
                        };
                        //console.log(scope.selected.availableStates[0].code)

                        //scope.selected.value = 'MT';
                        scope.address.state.value = scope.selected.availableStates[0].code;
                    });
                }
                if (scope.address.country.value.code == 'MX') {
                    console.log(value.code);
                    if (scope.address && scope.address.postalCode.value != "") {
                        scope.is_mxZipCode(scope.address.postalCode.value);
                    }
                }
                /*if(scope.address.country.value.code == 'AU'){
                	console.log(value.code);
                	if(scope.address && scope.address.postalCode.value !=""){
                		scope.is_auZipCode(scope.address.postalCode.value);
                	}
                	const StateListPromise = AccountService.getStates(value.code);
                	StateListPromise.then((data) => {        		
                		scope.availableStates=[];
                		angular.forEach(data,function(result,resultkey){
                    		scope.result = result.split('~');
                    		scope.availableStates.push(scope.result);
                    		
                    	});	
                		scope.desiredArray=[]
                    	angular.forEach(scope.availableStates, function(splitedvalues){
                    		console.log(splitedvalues)
                    		scope.desiredArray.push({name: splitedvalues[0], code: splitedvalues[1]});
                    	});
                          	//console.log(scope.selected);
                          	scope.selected = { 
                          	"value":scope.desiredArray[0],
                  		    "availableStates": scope.desiredArray 
                  		  };
                          	//console.log(scope.selected.availableStates[0].code)
                 	
                          	//scope.selected.value = 'MT';
                 	scope.address.state.value = scope.selected.availableStates[0].code;
                    });
                	
                }*/
                if (scope.address.country.value.code == 'CA') {
                    console.log(value.code);
                    if (scope.address && scope.address.postalCode.value != "") {
                        scope.is_caZipCode(scope.address.postalCode.value);
                    }
                    var _StateListPromise = AccountService.getStates(value.code);
                    _StateListPromise.then(function (data) {

                        scope.availableStates = [];
                        angular.forEach(data, function (result, resultkey) {
                            scope.result = result.split('~');
                            scope.availableStates.push(scope.result);
                        });
                        scope.desiredArray = [];
                        angular.forEach(scope.availableStates, function (splitedvalues) {
                            console.log(splitedvalues);
                            scope.desiredArray.push({ name: splitedvalues[0], code: splitedvalues[1] });
                        });
                        //console.log(scope.selected);
                        scope.selected = {
                            "value": scope.desiredArray[0],
                            "availableStates": scope.desiredArray
                        };
                        //console.log(scope.selected.availableStates[0].code)

                        //scope.selected.value = 'MT';
                        scope.address.state.value = scope.selected.availableStates[0].code;
                    });
                }
                if (scope.address.country.value.code != 'US' && scope.address.country.value.code != 'CA' && scope.address.country.value.code != 'MX') {
                    scope.selected.value = '';
                    scope.address.state.value = '';
                    //if(value.length == 0){
                    delete scope.address.state.value;
                    //}
                }
            });
            scope.selectedState = function (selected) {
                console.log(selected);
                scope.address.state.value = selected.code;
            };
            scope.selectedCountry = function (selectedcountry) {
                //console.log(selected);
                scope.address.country.value = selectedcountry.code;
                console.log(scope.address.country.value);
            };
            function syncAddressData() {
                //console.log(scope.address.country.value.code);
                if (scope.address.value) {
                    scope.address.country.value = scope.address.country.value || defaultCountryCode;
                    scope.address.state.value = scope.address.state.value;
                    //console.log("available country****")
                } else {
                    scope.address.value = {
                        country: defaultCountryCode
                    };
                }
            }

            scope.$watch('address.value', syncAddressData);
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/inputs/AddressDetails.js
// module id = 1964
// module chunks = 0